<template>
  <div class="container">
    <navigation/>
    <div class="wrapper">
      <h2>Teksty na stronie</h2>
      <ul class="textList">
        <li class="single-item" v-for="text in texts" :key="text.id">
          <div class="row">
          <h3>{{text.title}}</h3>
          <p @dblclick="editText(text)">{{text.content}}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="center">
      <router-link tag="button" class="backBtn" to="/admin">Wróć na główną strone</router-link>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Footer from '@/components/Footer.vue';
import navigation from '@/components/adminNav.vue';
export default {
  components:{
    Footer, navigation
  },
  computed:{
    ...mapState({
      texts: state=>state.textsAdmin.textsAdmin
    })
  },
  methods:{
    ...mapMutations(['bindAdminTexts']),
    ...mapActions(['editText'])
  },
  mounted(){
    if(!this.texts.length > 0){
      this.bindAdminTexts();
    }
  }
}
</script>

<style scoped lang="scss">
.row{
  display: flex;
  flex-direction: column;
  width: 400px;
}
.single-item{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 3px 0;
}
.editText{
  width: 100%;
  height: 40px;
  padding: 0 12px;
}
.backBtn{
  color: white;
  background: black;
  border: none;
  padding: 12px 24px;
  margin: 24px 0;
}
.center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper{
  margin-top: 120px;
  padding: 0 34px;
}
.footer_container{
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>